import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { colors, Item, Tooltip } from '@twnel/web-components';

const SpacedItem = styled(Item)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3rem;
  padding: 0 1rem;
  ${({ notEvent }) => (notEvent ? 'cursor: default' : '')};

  ${({ lightSelector }) => (lightSelector ? `
    &>:nth-child(${lightSelector}) {
      color: #${colors.blueGray};
    }
  ` : '')}

  & > ${Tooltip} {
    display: flex;
  }
`;

SpacedItem.defaultProps = {
  lightSelector: null,
  notEvent: false,
};

SpacedItem.propTypes = {
  lightSelector: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  notEvent: PropTypes.bool,
};

export default SpacedItem;
